import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import isEmpty from 'lodash/isEmpty';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

// GLOBAL VARIABLES
import { DAYS } from 'globals.js';

// CORE COMPONENTS
import Form from 'core/form/Form';

// VARIABLES
const DAYS_OF_WEEK = DAYS.reduce((array, day, index) => [...array, {
  value: index + 1,
  label: day.slice(0, ['S', 'T'].includes(day.slice(0, 1)) ? 2 : 1)
}], [])
const DAYS_OF_MONTH = [...Array(29).keys(), {
  value: 0,
  label: 'Last Day'
}].filter(option => !!option)

// MAIN COMPONENT
const EmailFrequencyDay = props => {

  // REACT REDUX
  const { reportEmailFrequency = [] } = useSelector(({ lookups }) => lookups);

  // FORMIK CONTEXT
  const { values } = useFormikContext() || {};

  // CALLBACKS
  const frequencyID = useCallback(
    frequency => {
      if (isEmpty(reportEmailFrequency)) return undefined;
      return reportEmailFrequency.filter(({ report_email_frequency_code }) => report_email_frequency_code === frequency)[0]?.report_email_frequency_id;
    },
    [reportEmailFrequency]
  )

  // MEMOS
  const [
    isWeekly,
    isMonthly
  ] = useMemo(
    () => [
      parseInt(values.report_email_frequency_id) === frequencyID('weekly'),
      parseInt(values.report_email_frequency_id) === frequencyID('monthly')
    ],
    [values, frequencyID]
  )
  
  return isWeekly ? (
    <Form.Checklist
      name="day_of_week"
      label="Day of the Week"
      options={DAYS_OF_WEEK}
      list={{
        cols: {
          xs: 'auto'
        }
      }}
      useCSV
      required
      fullWidth
      {...props}
    />
  ) : isMonthly ? (
    <Form.Select
      name="day_of_month"
      label="Day of the Month"
      options={DAYS_OF_MONTH}
      required
      {...props}
    />
  ) : null;
};

// EXPORT
export default EmailFrequencyDay;
